export default __webpack_public_path__ + "static/Крысиные бега-2c1795983a815639c6f79bcdc419a4c4.jpg";